
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_1yco7_97",
  "fit-height": "awsui_fit-height_14iqq_1yco7_111",
  "with-side-media": "awsui_with-side-media_14iqq_1yco7_116",
  "variant-default": "awsui_variant-default_14iqq_1yco7_119",
  "variant-stacked": "awsui_variant-stacked_14iqq_1yco7_119",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_1yco7_172",
  "with-top-media": "awsui_with-top-media_14iqq_1yco7_184",
  "content-wrapper": "awsui_content-wrapper_14iqq_1yco7_189",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_1yco7_194",
  "media": "awsui_media_14iqq_1yco7_199",
  "media-top": "awsui_media-top_14iqq_1yco7_217",
  "media-side": "awsui_media-side_14iqq_1yco7_222",
  "header": "awsui_header_14iqq_1yco7_228",
  "header-with-media": "awsui_header-with-media_14iqq_1yco7_233",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1yco7_239",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1yco7_243",
  "header-stuck": "awsui_header-stuck_14iqq_1yco7_249",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_1yco7_259",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1yco7_262",
  "with-paddings": "awsui_with-paddings_14iqq_1yco7_268",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_1yco7_277",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_1yco7_328",
  "dark-header": "awsui_dark-header_14iqq_1yco7_343",
  "content": "awsui_content_14iqq_1yco7_189",
  "content-fit-height": "awsui_content-fit-height_14iqq_1yco7_351",
  "content-with-media": "awsui_content-with-media_14iqq_1yco7_361",
  "footer": "awsui_footer_14iqq_1yco7_365",
  "with-divider": "awsui_with-divider_14iqq_1yco7_369"
};
  